export default {
  ressubmit_review: "Submit Review",
  resreview_products: "Review Products",
  resselect_product: "Select Product",
  resselect_product_placeholder: "-- Select Product --",
  resrating: "Rating",
  resreview_text: "Review Text",
  reswrite_feedback: "Write your feedback...",
  resupload_photo: "Upload Photo",
  resupload: "Upload",
  resmy_reviews: "My Submitted Reviews",
  resloading_reviews: "Loading reviews...",
  resproduct: "Product",
  resreview: "Review",
  resphoto: "Photo",
  resclose: "Close",
  resselect_product_error: "Please select a product",
  resload_items_error: "Failed to load order items",
  ressuccess_review: "Review submitted successfully!",
  resreview_failed: "Review submission failed",

  ResreviewsRatings: "Reviews & Ratings",
  ResreviewsSubtitle: "View Delivered Orders and Submit Reviews",
  ResreviewLoadFailed: "Failed to load delivered orders",
  ResorderId: "Order ID",
  Ressupplier: "Supplier",
  Resaction: "Action",
  ResnoDeliveredOrders: "No Delivered Orders Found",
};